import "./Hero.scss";
import bubblesTop from "../../../assets/images/BubbleGroup2.svg";
import bubblesBottom from "../../../assets/images/BubbleGroup1.svg";
import { Image } from "../../common/image/Image";
// import trustpilotLogo from "../../../assets/images/trustpilot-logo-light.webp";

const Hero = ({ short, title }) => {
  return (
    <section id="home" className="section section--hero static--hero">
      <Image src={bubblesTop} alt="" className="bubbles-top" />
      <Image src={bubblesBottom} alt="" className="bubbles-bottom" />
      <div className="section__innerWrapper">
        <article>
          {/* <img src={trustpilotLogo} alt="Trustpilot logo" className="trustpilotLogo" /> */}
          <h1>{title}</h1>
          <p>{short.split("<br>").join("\n")}</p>
          <a href="#apply-now" title="Apply now" className="apply-now-button">
            <button className="button primary">
              Apply now
            </button>
          </a>
        </article>
        <Image
          src={`${process.env.PUBLIC_URL}/hero.webp`}
          alt="Smiling graduate in a cap and gown hugging an older adult, celebrating after receiving a diploma"
          className="heroImage"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width={1920}
          height={960}
        />
        <a href="#apply-now" className="applyNowBtn">
          <span>Contact us</span>
        </a>
      </div>
    </section>
  );
};

export default Hero;
